<div class="form-feedbacks" *ngIf="field.dirty && field.invalid">
	<div class="invalid-feedback" *ngIf="field.hasError('required')">
		{{ messages.Required || 'ValidationErrors.Required' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('emailRequired')">
		{{ messages.RequiredEmail || 'ValidationErrors.RequiredEmail' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('pattern')">
		{{ messages.Format || 'ValidationErrors.Format' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('noWhitespaceRequired')">
		{{ messages.NoWhitespace || 'ValidationErrors.NoWhitespace' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('noEmptyString')">
		{{ messages.NoEmptyString || 'ValidationErrors.NoEmptyString' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('noEmptyValue')">
		{{
			(messages.NoEmpty || 'ValidationErrors.NoEmpty') +
				field.errors['noEmptyValue']['type'].charAt(0).toUpperCase() +
				field.errors['noEmptyValue']['type'].substr(1) | translate: { defaultValue: field.errors['noEmptyValue']['defaultValue'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('email')">
		{{ messages.Email || 'ValidationErrors.Email' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('invalidVerificationCode')">
		{{ messages.ValidVerificationCode || 'ValidationErrors.ValidVerificationCode' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('validatePhoneNumber')">
		{{ 'ValidationErrors.ValidVerificationTelephone' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('requireDocumentUpload')">
		{{ 'ValidationErrors.RequireDocumentUpload' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('invalidCurrentPassword')">
		{{ messages.WrongCurrentPassword || 'Company.Password.WrongCurrentPassword' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('emailAlreadyUsed')">
		{{ messages.EmailAlreadyUsed || 'ValidationErrors.EmailAlreadyUsed' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('passwordAlreadyUsed')">
		{{ messages.PasswordAlreadyUsed || 'ValidationErrors.PasswordAlreadyUsed' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('codeAlreadyUsed')">
		{{ messages.codeAlreadyUsed || 'ValidationErrors.CodeAlreadyUsed' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('barreauReferenceUncaAlreadyUsed')">
		{{ messages.barreauReferenceUncaAlreadyUsed || 'ValidationErrors.BarreauReferenceUncaAlreadyUsed' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('carpaReferenceUncaAlreadyUsed')">
		{{ messages.carpaReferenceUncaAlreadyUsed || 'ValidationErrors.CarpaReferenceUncaAlreadyUsed' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('libelleAlreadyUsed')">
		{{ messages.libelleAlreadyUsed || 'ValidationErrors.LibelleAlreadyUsed' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('forbiddenValue')">
		{{ messages.ForbiddenValue || 'ValidationErrors.ForbiddenValue' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('numberRequired')">
		{{ messages.Number || 'ValidationErrors.Number' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('minlength')">
		{{
			messages.MinLength || 'ValidationErrors.MinLength'
				| plural: field.errors['minlength']['requiredLength']
				| translate: { count: field.errors['minlength']['requiredLength'] }
		}}
	</div>

	<div class="invalid-feedback" [ngStyle]="{ width: isFullWidth ? '100%' : '' }" *ngIf="field.hasError('maxlength')">
		{{
			messages.MaxLength || 'ValidationErrors.MaxLength'
				| plural: field.errors['maxlength']['requiredLength']
				| translate: { count: field.errors['maxlength']['requiredLength'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('exactLength')">
		{{
			messages.ExactLength || 'ValidationErrors.ExactLength'
				| plural: field.errors['exactLength']['requiredLength']
				| translate: { count: field.errors['exactLength']['requiredLength'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('exactLengthNumber')">
		{{
			messages.exactLengthNumber || 'ValidationErrors.ExactLengthNumber'
				| plural: field.errors['exactLengthNumber']['requiredLength']
				| translate: { count: field.errors['exactLengthNumber']['requiredLength'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('min')">
		{{ messages.Min || 'ValidationErrors.Min' | translate: { count: field.errors['count'] } }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('greaterThan')">
		{{ messages.GreaterThan || 'ValidationErrors.GreaterThan' | translate: { count: field.errors['count'] } }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('lessThan')">
		{{ messages.LessThan || 'ValidationErrors.LessThan' | translate: { count: field.errors['count'] } }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('lessThanOrEqual')">
		{{ messages.LessThanOrEqual || 'ValidationErrors.LessThanOrEqual' | translate: { count: field.errors['count'] } }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('minNbCheques')">
		{{ messages.Min || 'ValidationErrors.MinNbCheques' | translate: { count: field.errors['count'] } }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('max')">
		{{ messages.Max || 'ValidationErrors.Max' | translate: { count: field.errors['max']['max'] } }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('mismatchedPasswords')">
		{{ messages.MismatchedPasswords || 'ValidationErrors.MismatchedPasswords' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('lowercaseCharacterRule')">
		{{
			messages.LowercaseCharacterRule || 'ValidationErrors.LowercaseCharacterRule'
				| plural: field.errors['lowercaseCharacterRule']['required']
				| translate: { count: field.errors['lowercaseCharacterRule']['required'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('uppercaseCharacterRule')">
		{{
			messages.UppercaseCharacterRule || 'ValidationErrors.UppercaseCharacterRule'
				| plural: field.errors['uppercaseCharacterRule']['required']
				| translate: { count: field.errors['uppercaseCharacterRule']['required'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('specialCharacterRule')">
		{{
			messages.SpecialCharacterRule || 'ValidationErrors.SpecialCharacterRule'
				| plural: field.errors['specialCharacterRule']['required']
				| translate: { count: field.errors['specialCharacterRule']['required'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('digitCharacterRule')">
		{{
			messages.DigitCharacterRule || 'ValidationErrors.DigitCharacterRule'
				| plural: field.errors['digitCharacterRule']['required']
				| translate: { count: field.errors['digitCharacterRule']['required'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('ngbDate')">
		{{ messages.Format || 'ValidationErrors.Format' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('validDate')">
		{{ messages.ValidDate || 'ValidationErrors.ValidDate' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('beforeNow')">
		{{ messages.BeforeNow || 'ValidationErrors.BeforeNow' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('afterNow')">
		{{ messages.AfterNow || 'ValidationErrors.AfterNow' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('olderThanDays')">
		{{
			messages.OlderThanDays || 'ValidationErrors.OlderThanDays'
				| plural: field.errors['olderThanDays']['days']
				| translate: { days: field.errors['olderThanDays']['days'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('notOlderThanDays')">
		{{
			messages.NotOlderThanDays || 'ValidationErrors.NotOlderThanDays'
				| plural: field.errors['notOlderThanDays']['days']
				| translate: { days: field.errors['notOlderThanDays']['days'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('youngerThanDays')">
		{{
			messages.YoungerThanDays || 'ValidationErrors.YoungerThanDays'
				| plural: field.errors['youngerThanDays']['days']
				| translate: { days: field.errors['youngerThanDays']['days'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('invalidIdentifier')">
		{{ messages.InvalidIdentifier || 'ValidationErrors.InvalidIdentifier' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('iban')">
		{{ messages.Iban || 'ValidationErrors.Iban' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('frenchIban')">
		{{ messages.FrenchIban || 'ValidationErrors.FrenchIban' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('rangeInconsistency')">
		{{ messages.RangeInconsistency || 'ValidationErrors.RangeInconsistency' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('atLeastOnePartieRequired')">
		{{ messages.AtLeastOnePartieRequired || 'ValidationErrors.AtLeastOnePartieRequired' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('atLeastOneTypeOperationRequired')">
		{{ messages.AtLeastOneTypeOperationRequired || 'ValidationErrors.AtLeastOneTypeOperationRequired' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('libelleMajuscules')">
		{{ messages.LibelleMajuscules || 'ValidationErrors.LibelleMajuscules' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('libelleContraint')">
		{{ messages.LibelleContraint || 'ValidationErrors.LibelleContraint' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('notAllowedTerm')">
		{{ messages.NotAllowedTerm || 'ValidationErrors.NotAllowedTerm' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('notEqual')">
		{{
			messages.NotEqual || 'ValidationErrors.NotEqual'
				| translate
					: { propertyName: field.errors['notEqual']['propertyName'], valueToCompare: field.errors['notEqual']['valueToCompare'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('allFacteursNotVerified')">
		{{ messages.AllFacteursNotVerified || 'ValidationErrors.AllFacteursNotVerified' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('emailInvalid')">
		{{ messages.emailInvalid || 'ValidationErrors.emailInvalid' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('phoneNumberInvalid')">
		{{ messages.phoneNumberInvalid || 'ValidationErrors.phoneNumberInvalid' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('notEqualMonthlySum')">
		{{ messages.notEqualMonthlySum || 'ValidationErrors.notEqualMonthlySum' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('carpaForbiddenValue')">
		{{ messages.CarpaForbiddenValue || 'ValidationErrors.CarpaForbiddenValue' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('notBetweenNumber')">
		{{
			messages.notBetweenNumber || 'ValidationErrors.notBetweenNumber'
				| translate: { fromVal: field.errors['notBetweenNumber']['fromVal'], toVal: field.errors['notBetweenNumber']['toVal'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('ibanLength')">
		{{
			messages.ibanLength || 'ValidationErrors.ibanLength'
				| translate: { pays: field.errors['ibanLength']['pays'], longueurIban: field.errors['ibanLength']['longueurIban'] }
		}}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('ibanFormatISO')">
		{{ messages.ibanFormatISO || 'ValidationErrors.ibanFormatISO' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongIbanKey')">
		{{ messages.wrongIbanKey || 'ValidationErrors.wrongIbanKey' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongSwiftBicLength')">
		{{ messages.wrongSwiftBicLength || 'ValidationErrors.wrongSwiftBicLength' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('documentRequired')">
		{{ 'ValidationErrors.RequireDocument' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('sensOperationRequired')">
		{{ 'ValidationErrors.RequiredSens' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('requiredCommentOrDocument')">
		{{ messages.RequiredCommentOrDocument || 'ValidationErrors.RequiredCommentOrDocument' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongSirenLength')">
		{{ messages.wrongSirenLength || 'ValidationErrors.wrongSirenLength' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongSiretLength')">
		{{ messages.wrongSiretLength || 'ValidationErrors.wrongSiretLength' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongTVAFormat')">
		{{ messages.wrongTVAFormat || 'ValidationErrors.WrongTVAFormat' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongTelephoneLength')">
		{{ messages.wrongTelephoneLength || 'ValidationErrors.WrongTelephoneLength' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('wrongRegistreEquivalentLength')">
		{{ messages.wrongRegistreEquivalentLength || 'ValidationErrors.wrongRegistreEquivalentLength' | translate }}
	</div>

	<div class="invalid-feedback" [ngStyle]="{ width: isFullWidth ? '100%' : '' }" *ngIf="field.hasError('wrongRcsFormat')">
		{{ messages.wrongRcsFormat || 'ValidationErrors.wrongRcsFormat' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('swiftFormatISO')">
		{{ messages.swiftFormatISO || 'ValidationErrors.swiftFormatISO' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('requiredDocumentByType')">
		{{ messages.RequiredDocumentByType || 'ValidationErrors.RequiredDocumentByType' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('amountDeLessOrEqualA')">
		{{ messages.amountDeLessOrEqualA || 'ValidationErrors.amountDeLessOrEqualA' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('amountAGreaterThanDe')">
		{{ messages.amountAGreaterThanDe || 'ValidationErrors.amountAGreaterThanDe' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('numeroAffaireInvalide')">
		{{ messages.numeroAffaireInvalide || 'ValidationErrors.numeroAffaireInvalide' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('dateRange')">
		{{ 'ValidationErrors.DateRangeInvalid' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('dateRangeFromError')">
		{{ 'ValidationErrors.DateRangeFromInvalid' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('dateRangeToError')">
		{{ 'ValidationErrors.DateRangeToInvalid' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('invalidDateError')">
		{{ 'ValidationErrors.DateInvalid' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('invalidNomEmetteurQual')">
		{{ 'ValidationErrors.InvalidNomEmetteurQual' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('invalidNomEmetteurQualAAD')">
		{{ 'ValidationErrors.InvalidNomEmetteurQualAAD' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('codeBanqueDoublon')">
		{{ 'ValidationErrors.CodeBanqueDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('libelleBanqueDoublon')">
		{{ 'ValidationErrors.LibelleBanqueDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('codeAgenceDoublon')">
		{{ 'ValidationErrors.CodeAgenceDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('nomAgenceDoublon')">
		{{ 'ValidationErrors.NomAgenceDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('userEmailDoublon')">
		{{ 'ValidationErrors.EmailUserDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('ibanCompteBancaireDoublon')">
		{{ 'ValidationErrors.IbanCompteBancaireDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('numeroCompteBancaireDoublon')">
		{{ 'ValidationErrors.NumeroCompteBancaireDoublon' | translate }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('isCompteBancaireRefExistAlready')">
		{{ 'ValidationErrors.IsCompteBancaireRefExistAlready' | translate: { iban: field.errors['isCompteBancaireRefExistAlready']['iban'], nomCompte: field.errors['isCompteBancaireRefExistAlready']['nomCompte']} }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('invalidFileType')">
		{{ 'ValidationErrors.InvalidFileType' | translate: { allowedTypes: field.errors['invalidFileType']['allowedTypes'] } }}
	</div>
	<div class="invalid-feedback" *ngIf="field.hasError('amountGreaterThan')">
		{{ 'ValidationErrors.MontantMinRibAuto' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('amountLessOrEqualThan')">
		{{ 'ValidationErrors.MontantMaxRibAuto' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('duplicateValue')">
		{{ 'ValidationErrors.DuplicateValue' | translate }}
	</div>

	<div class="invalid-feedback" *ngIf="field.hasError('luhnInvalid')">
		{{ messages.LuhnInvalid || 'ValidationErrors.LuhnInvalid' | translate }}
	</div>

